import { createLogic } from 'redux-logic';
import { CUSTOMER_URL, FAVORITE_CUSTOMER_URL, VALIDATE_PROPOSALS_URL } from 'utils/api';
import { toastr } from 'react-redux-toastr';
import { LOAD_CLIENTS, FAVORITE_CLIENT, UPDATE_CLIENT, VERIFY_RISK_CLIENT, UPLOAD_CLIENTS } from '../constants/clients';
import { buildPayloadRequest } from './proposal';
import { getClientStatusLabel } from 'utils/client';
import { toCapitalizeCase, convertNumberBR } from 'utils/helpers';

import {
  FavoriteClientSuccess,
  FavoriteClientError,
  LoadClientsSuccess,
  LoadClientsError,
} from '../actions/clients';
import normalize from '../models/clients';

const FavoriteClient = createLogic({
  type: FAVORITE_CLIENT,

  process({ requestUtil, action }, dispatch, done) {
    const client = action.payload;

    const options = ({
      method: 'PUT',
      data: {
        cliente: client.clienteId,
        favorito: !client.favorito,
      }
    });

    requestUtil(FAVORITE_CUSTOMER_URL, options).then((response) => {
      setTimeout(() => {
        if (!response) {
          dispatch(FavoriteClientError(client));
          toastr.error('Erro ao favoritar cliente', 'tente novamente');
        } else {
          dispatch(FavoriteClientSuccess(client));
        }

        done();
      }, 1000);
    })
  },
});

const getClient = async (search, operationId, requestUtil) => {
  let queryParam = search ? `/filtro?Filtro=${search}` : '?cached=true';
  queryParam += `&OperacaoId=${operationId}`;

  const response = await requestUtil(`${CUSTOMER_URL}${queryParam}`, 1800000).then((response) => {
    if (response.error) {
      toastr.error(`Erro ao carregar cliente ${search ? search : ''}`, 'tente novamente');
      return null;
    } else {
      const { clientes } = response;
      return clientes;
    }
  });

  return response;
}

const LoadClients = createLogic({
  type: LOAD_CLIENTS,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const { payload, operationId } = action;

    const loadClient = async () => {
      let client = await getClient(payload, operationId, requestUtil);
      if (client.length > 0) {
        client = normalize(client);
      }

      dispatch(LoadClientsSuccess(client));
      done();
    }
    loadClient();
  },
});

const UploadClients = createLogic({
  type: UPLOAD_CLIENTS,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const { clients, operationId } = action;

    const clientsLoaded = Promise.all(clients?.map(async element => {
      return await getClient(element.clientId, operationId, requestUtil);
    }));

    clientsLoaded.then(response => {
      const clientsResponse = response.filter(client => client && client.length > 0);

      if (clientsResponse.length > 0) {
        const clientsNormalized = clientsResponse.map(newClient => {
          const quantity = clients?.filter(c => c.clientId === newClient[0].clienteId)[0].quantity;

          return {
            ...normalize(newClient)[0],
            isSelected: true,
            quantity,
            quantityView: convertNumberBR(quantity)
          }
        });

        toastr.info('Importação concluída', 'Clientes carregados com sucesso');

        dispatch(LoadClientsSuccess(clientsNormalized));
      } else {
        toastr.info('Importação concluída', 'Clientes carregados');
        dispatch(LoadClientsError(null));
      }
      done();
    })
  },
});

const UpdateClient = createLogic({
  type: UPDATE_CLIENT,
  latest: true,

  process({ requestUtil, action, getState }, dispatch, done) {
    const { payload, operationId } = action;

    requestUtil(`${CUSTOMER_URL}/filtro?Filtro=${payload}&Cached=false&OperacaoId=${operationId}`, 1800000).then((response) => {
      if (response.error) {
        dispatch(LoadClientsError(response.error));
        toastr.error('Erro ao carregar cliente', 'tente novamente');
      } else {
        const { Clients } = getState();
        const clientUpdated  = response.clientes[0];
        const clientsUpdated = Clients.clients.map(client => (
          client.clienteId === clientUpdated.clienteId
            ? {
              ...client,
              assessor: clientUpdated.assessor,
              favorito: clientUpdated.favorito,
              habilitado: clientUpdated.habilitado,
              termoAceito: clientUpdated.termoAceito,
              ehMaiorDeIdade: clientUpdated.ehMaiorDeIdade,
              pushHabilitado: clientUpdated.pushHabilitado,
              ehClubeInvestimento: clientUpdated.ehClubeInvestimento,
              impedimentsMessage: getClientStatusLabel(client),
              suitability: toCapitalizeCase(client.suitability),
            }
            : client
        ));

        dispatch(LoadClientsSuccess(clientsUpdated));
      }
    }).then(done);
  },
});

const VerifyRiskClient = createLogic({
  type: VERIFY_RISK_CLIENT,
  latest: true,

  process({ requestUtil, action, getState }, dispatch, done) {
    const payload = buildPayloadRequest(action.payload);
    const clientsSended = action.payload.clients;

    requestUtil(VALIDATE_PROPOSALS_URL, {
      method: 'POST',
      data: payload
    })
      .then((response) => {
      const { Clients } = getState();
      const errors = response?.mensagens;

      const verifiedClients = clientsSended.map(client => {
        const clientError = errors.find(error => error?.erro && error?.clientId === client?.clienteId);
        const riskValidated = !Boolean(clientError);

        return {
          ...client,
          isSelected: riskValidated,
          riskValidated: riskValidated,
          mensagemErrorStatus: riskValidated ? '' : clientError.descricao,
          riskError: riskValidated ? false : clientError.erro
        }
      });

      const clientsUpdated = Clients.clients.map(client => {
        const verifiedClient = verifiedClients.find(cli => cli.clienteId === client.clienteId);
        return verifiedClient ? verifiedClient : client
      });

      dispatch(LoadClientsSuccess(clientsUpdated));

    }).then(done);
  },
});

export default [FavoriteClient, LoadClients, UpdateClient, VerifyRiskClient, UploadClients];
